import { Heading, HStack, Icon } from "@chakra-ui/react";
import { SortDirection } from "lib/types";
import { HiOutlineArrowNarrowDown } from "@react-icons/all-files/hi/HiOutlineArrowNarrowDown";
import { HiOutlineArrowNarrowUp } from "@react-icons/all-files/hi/HiOutlineArrowNarrowUp";
import { FC } from "react";

type Props = {
  onClick: (key: string) => void;
  direction: SortDirection;
  sortKey: string;
  currentKey: string;
  label: string;
}

export const SortHeader: FC<Props> = ({ onClick, currentKey, direction, sortKey, label }) => {
  const Arrow = direction === SortDirection.asc ?  HiOutlineArrowNarrowUp : HiOutlineArrowNarrowDown;

  return (
    <HStack onClick={() => onClick(sortKey)} className={`heap-sort-by-${sortKey}`} width={"auto"} display={"inline-flex"}>
      <Heading
        size={"sm"}
        fontWeight={600}
        layerStyle={['with-clickable-text']}
        color={currentKey === sortKey ? 'brand.500' : 'text.100'}
      >
        { label }
      </Heading>
      {currentKey === sortKey && (
        <Icon as={Arrow} boxSize="18px" color={currentKey === sortKey ? 'brand.500' : 'text.100'} />
      )}
    </HStack>
  )
}